import React, { useEffect, useState } from "react";
import "./user.css";
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../../firebase";

const User = ({ user1, user, selectUser, chat }) => {
  const user2 = user?.uid;
  const [data, setData] = useState("");

  useEffect(() => {
    const id = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`;
    let unsub = onSnapshot(doc(db, "lastMsg", id), (doc) => {
      setData(doc.data());
    });
    return () => unsub();
  }, []);

  return (
    <>
      <div
        className={`user_wrapper ${chat.name === user.name && "selected_user"}`}
        onClick={() => selectUser(user)}
      >
        <div className="user_info">
          <div className="user_detail">
            <img
              src={
                user.avatar ||
                "https://www.indieweek.com/wp-content/uploads/2019/08/profile-icon-300x300.png"
              }
              alt="avatar"
              className="avatar"
            />

            <div className="user-vert">
              <div className="user-new">
                <h4>{user.name}</h4>
                {data?.from !== user1 && data?.unread && (
                  <small className="unread">New</small>
                )}
              </div>

              {data && (
                <p className="truncate">
                  <strong>{data.from === user1 ? "Me:" : null}</strong>
                  {data.text}
                </p>
              )}
            </div>
          </div>

          <div
            className={`user_status ${user.isOnline ? "online" : "offline"}`}
          ></div>
        </div>
      </div>

      <div
        onClick={() => selectUser(user)}
        className={`sm_container ${chat.name === user.name && "selected_user"}`}
      >
        <img
          src={
            user.avatar ||
            "https://www.indieweek.com/wp-content/uploads/2019/08/profile-icon-300x300.png"
          }
          alt="avatar"
          className="avatar sm_screen"
        />
      </div>
    </>
  );
};

export default User;
